import Nullstack from 'nullstack';
import Checkout from './Checkout'

class CheckoutPage extends Nullstack {

  static hash = '8380239db88e0111d39ecc3f57421e74';

  prepare({ project, page }) {
    page.title = `${project.name} - Pré-cadastro curso Python Turbo`;
    page.description = `${project.name} Falta pouco...`;
    page.locale = 'pt-BR';
    page.image = '/image-1200x630.png';
  }

  render() {
    return (
        // bg-[#1e1e1e]
      <section >
        <Checkout />
      </section>
    );
  }

}

export default CheckoutPage;
if (module.hot) { module.hot.accept(); Nullstack.updateInstancesPrototypes(CheckoutPage, CheckoutPage.hash, 'd41d8cd98f00b204e9800998ecf8427e') }